import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateBannerAction = createAsyncThunk(
    'update-banner',
    async (data, { rejectWithValue }) => {
        console.log("data12-->",data)
        try {
            const res = await axios.put(`/admins/api/update-banner`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateBannerSlice = createSlice({
    name: 'update-banner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateBannerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateBannerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateBannerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateBannerReducer = updateBannerSlice.reducer